import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Upload } from '../../../../../Common';

import './index.scss';

const MutateTasksListImage = ({ language, type, name, onSubmit, ...props }) => {
  const [field, , fieldHelpers] = useField(name);

  return (
    <div
      {...props}
      className={classNames(
        'mutate-tasks-list-image',
        // eslint-disable-next-line react/destructuring-assignment
        props.className,
      )}
    >
      <h5>Image</h5>
      <input type="hidden" value={field.value} />
      <Upload
        {...props}
        name={name}
        lang={language}
        type={type}
        uploaded={field.value ? [field.value] : ''}
        onSubmit={({ files }) => {
          fieldHelpers.setValue(files[0]);
          fieldHelpers.setTouched(true);
          onSubmit(files[0]);
        }}
        onDelete={() => {
          fieldHelpers.setValue('');
          fieldHelpers.setTouched(false);
        }}
        onCopy={() => {}}
        className={classNames(
          'mutate-tasks-list-image',
          // eslint-disable-next-line react/destructuring-assignment
          props.className,
        )}
      />
    </div>
  );
};

export default MutateTasksListImage;
